import { render, staticRenderFns } from "./StrengthsAndWeaknessesCard.vue?vue&type=template&id=9936daec&scoped=true"
import script from "./StrengthsAndWeaknessesCard.vue?vue&type=script&lang=js"
export * from "./StrengthsAndWeaknessesCard.vue?vue&type=script&lang=js"
import style0 from "./StrengthsAndWeaknessesCard.vue?vue&type=style&index=0&id=9936daec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9936daec",
  null
  
)

export default component.exports